<template>
  <v-list three-line key="lista">
    <template v-for="(servico, index) in servicos">
      <v-list-tile
        :key="servico.chave+index"
        avatar
      >
        <v-list-tile-avatar>
              <v-img :src="imagens[servico.chave] || ''">
                <template v-slot:placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5" size="20"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ servico.data }} - {{ servico.cliente }}</v-list-tile-title>
          <v-list-tile-sub-title class="text--primary">
              {{ servico.tamanho }}'' / {{ servico.quantidade }} / {{ (servico.cor ? servico.cor : 'Sem Cor' ) }}<br>
              {{ servico.descricao }}
          </v-list-tile-sub-title>
          <v-list-tile-sub-title>{{ moment(servico.prazo).fromNow() }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-list-tile-action-text>{{ moment(servico.update).fromNow(true) }}</v-list-tile-action-text>

          <v-menu bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on"><v-icon>repeat</v-icon></v-btn>
            </template>
            <v-list>
              <v-list-tile flat v-for="produto in servico.departamentos" :disabled="!produto.id" :key="produto.id" @click="resetServico(produto)">
                <v-list-tile-title> Repetir <strong>{{ produto.departamento }}</strong></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

        </v-list-tile-action>
      </v-list-tile>
      <v-divider
        v-if="index + 1 < servicos.length"
        :key="index"
      ></v-divider>
    </template>
  </v-list>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Terminados',
  data: function() {
    return {
      servicos: [],
      imagens: {},
      timer: null,
      url: '',
    }
  },
  mounted(){
    let self = this
    moment.locale("pt")
    self.url = self.$http.defaults.baseURL
    self.getServicos()
  },
  created(){
    this.timer = setInterval(() => {
        this.getServicos()
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods:{
    moment(data){
      return moment(data)
    },
    urlToken:  function (url) {
      return url+"?level_token="+localStorage.getItem('level_token')+"&v="+Date.now()
    },
    getServicos: function(){
        let self = this
        self.$http.get('/auth/departamento-terminados').then(response => {
            self.servicos = response.data.servicos
            self.getImagens()
        })
        .catch(e => {
            this.errors.push(e)
        })
    },
    getImagens: function () {
      let self = this;
      let allChaves = self.servicos.map(s => s.chave).filter(Boolean);
      let chaves = allChaves.filter(chave => !self.imagens[chave]);
      if (!chaves.length) return;
      self.$http.post('/auth/servico-imagens-batch', { chaves: chaves })
        .then(response => {
          let data = response.data;
          let novas = {};
          for (let chave in data) {
            if (data[chave]) {
              novas[chave] = 'data:' + data[chave].content_type + ';base64,' + data[chave].imagem;
            }
          }
          self.imagens = Object.assign({}, self.imagens, novas);
        })
        .catch(() => {});
    },
    resetServico: function (produto) {
        let self = this
        if (!produto.id) return '';
        self.$http.get('/auth/departamento-reset/'+produto.id).then(() => {
            //self.servicos = response.data.servicos
            self.getServicos()
        })
        .catch(e => {
            this.errors.push(e)
        })
    }
  },
}
</script>